// Etiquetas heredadas de un ticket.
// Borrar una etiqueta en Ajustes NO hace cascada sobre los tickets que ya la
// usan, y el backend (updateTicket) las conserva al editar: sólo exige que las
// etiquetas NUEVAS estén configuradas. Sin esto, el panel sólo pintaba
// `settings.labels`, así que una etiqueta retirada quedaba invisible y sin
// forma de quitarla desde la UI.

export interface ConfiguredLabel {
  id: string;
}

/**
 * Ids que el ticket lleva pero que ya no están configurados en la Mesa de
 * Servicio. Se muestran como chips activos para poder quitarlos; una vez
 * quitados no se pueden volver a añadir (el backend responde 422).
 */
export function legacyTicketLabels(
  configured: ConfiguredLabel[] | undefined | null,
  ticketLabels: string[] | undefined | null,
): string[] {
  const configuredIds = new Set((configured || []).map((l) => l?.id));
  return (ticketLabels || []).filter((id) => typeof id === "string" && !configuredIds.has(id));
}
